module.exports = __webpack_public_path__ + "ui-static/img/export-border-left.105686b6.svg";